import * as LanguageConstants from "../constants";

export default function(state = {}, action) {
  switch (action.type) {
  case LanguageConstants.LANGUAGE_SUCCESS:
    return {
      ...state,
      [action.employeeId]: action.languages
    };
  case LanguageConstants.LANGUAGE_ADD_NEW:
    return {
      ...state,
      [action.employeeId]: [
        action.id, 
        ...state[action.employeeId]
      ]
    };
  case LanguageConstants.LANGUAGE_DELETE: {
    const deletedIndex = state[action.employeeId].indexOf(action.id);
    let languages = state[action.employeeId];
    languages.splice(deletedIndex, 1);
    return {
      ...state,
      [action.employeeId]: languages
    };
  }
  default:
    return state;
  }
}